const SLUGS = {
    homeaway_dk: {
        60: 'lader',
        61: 'bed-breakfast',
        62: 'både',
        63: 'bungalower',
        64: 'træhytter',
        65: 'slotte',
        66: 'skihytter',
        67: 'chateauer',
        69: 'sommerhuse',
        70: 'godser',
        71: 'bondegårde',
        72: 'gæstehuse',
        73: 'hoteller',
        74: 'feriehuse',
        75: 'husbåde',
        76: 'hytter',
        77: 'møller',
        78: 'mobilehomes-autocampere',
        79: 'resorter',
        80: 'studios',
        81: 'tårne',
        82: 'byhuse',
        83: 'villaer',
        84: 'yachter',
        92: 'ferielejligheder',
    },
    homeaway_at: {
        60: 'scheunen',
        61: 'bed-breakfasts',
        62: 'boote',
        63: 'bungalows',
        64: 'ferienhütten',
        65: 'schlösser',
        66: 'chalets',
        67: 'châteaus-landhäuser',
        69: 'kleine-landhäuser',
        70: 'anwesen',
        71: 'bauernhäuser',
        72: 'pensionen',
        73: 'hotels',
        74: 'häuser',
        75: 'hausboote',
        76: 'lodges',
        77: 'mühlen',
        78: 'mobilheime-wohnwagen',
        79: 'resorts',
        80: 'studios',
        81: 'türme',
        82: 'stadtdomizile',
        83: 'villen',
        84: 'jachten',
        92: 'apartments-wohnungen-in-einer-anlage',
    },
    homeaway_de: {
        23: 'pool',
        35: 'see',
        36: 'berge',
        44: 'luxus',
        60: 'scheunen',
        61: 'bed-breakfasts',
        62: 'boote',
        63: 'bungalows',
        64: 'hütten',
        65: 'schlösser',
        66: 'chalet',
        67: 'landhaus',
        69: 'kleine-landhäuser',
        70: 'anwesen',
        71: 'bauernhaus',
        72: 'gasthof',
        73: 'familienhotel',
        74: 'ferienhaus',
        75: 'hausboote',
        76: 'lodge',
        77: 'mühlen',
        78: 'wohnmobil',
        79: 'resorts',
        80: 'studio',
        81: 'türme',
        82: 'gästehaus',
        83: 'fincas-und-villen',
        84: 'jachten',
        91: 'am-meer',
        92: 'wohnungen',
    },
    homeaway_gr: {
        60: 'αχυρώνες',
        61: 'bed-breakfast',
        62: 'σκάφη',
        63: 'μπανγκαλόου',
        64: 'ξύλινες-καλύβες',
        65: 'κάστρα',
        66: 'σαλέ',
        67: 'πύργοι-εξοχικές-επαύλεις',
        69: 'εξοχικές-κατοικίες',
        70: 'επαύλεις',
        71: 'αγροικίες',
        72: 'ξενώνες',
        73: 'ξενοδοχεία',
        74: 'οικίες',
        75: 'πλωτά-σπίτια',
        76: 'καταφύγια',
        77: 'μύλοι',
        78: 'τροχοβίλες-τροχόσπιτα',
        79: 'θέρετρα',
        80: 'στούντιο',
        81: 'πύργοι',
        82: 'μονοκατοικίες',
        83: 'βίλες',
        84: 'γιοτ',
        92: 'διαμερίσματα',
    },
    homeaway_au: {
        1008: 'cheap',
        23: 'pool',
        27: 'pet-friendly',
        30: 'beach',
        32: 'beachfront',
        38: 'country-and-rural',
        39: 'ski-in-ski-out',
        42: 'waterfront',
        43: 'family',
        44: 'luxury',
        60: 'barns',
        61: 'bed-and-breakfasts',
        62: 'boats',
        63: 'bungalows',
        64: 'cabins',
        65: 'castles',
        66: 'chalets',
        67: 'country-houses',
        69: 'cottages',
        70: 'mansions',
        71: 'farm-stays',
        72: 'guest-houses',
        73: 'hotels',
        74: 'houses',
        75: 'houseboats',
        76: 'lodges',
        77: 'mills',
        78: 'caravans',
        79: 'resorts',
        80: 'studios',
        81: 'towers',
        82: 'townhouses',
        83: 'villas',
        84: 'yachts',
        92: 'apartments',
    },
    stayz: {
        1008: 'cheap',
        23: 'pool',
        27: 'pet-friendly',
        30: 'beach',
        32: 'beachfront',
        38: 'country-and-rural',
        39: 'ski-in-ski-out',
        42: 'waterfront',
        43: 'family',
        44: 'luxury',
        60: 'barns',
        61: 'bed-and-breakfasts',
        62: 'boats',
        63: 'bungalows',
        64: 'cabins',
        65: 'castles',
        66: 'chalets',
        67: 'country-houses',
        69: 'cottages',
        70: 'mansions',
        71: 'farm-stays',
        72: 'guest-houses',
        73: 'hotels',
        74: 'houses',
        75: 'houseboats',
        76: 'lodges',
        77: 'mills',
        78: 'caravans',
        79: 'resorts',
        80: 'studios',
        81: 'towers',
        82: 'townhouses',
        83: 'villas',
        84: 'yachts',
        92: 'apartments',
    },
    homeaway_ca: {
        1008: 'cheap',
        23: 'pool',
        27: 'pet-friendly',
        30: 'beach',
        32: 'beachfront',
        35: 'lakefront',
        36: 'mountain',
        42: 'waterfront',
        43: 'family',
        44: 'luxury',
        60: 'barns',
        61: 'bed-and-breakfasts',
        62: 'boats',
        63: 'bungalows',
        64: 'cabins',
        65: 'castles',
        66: 'chalets',
        67: 'country-houses',
        69: 'cottages',
        70: 'mansions',
        71: 'farms',
        72: 'guest-houses',
        73: 'hotels',
        74: 'houses',
        75: 'houseboats',
        76: 'lodges',
        77: 'mills',
        78: 'caravans',
        79: 'resorts',
        80: 'studios',
        81: 'towers',
        82: 'townhouses',
        83: 'villas',
        84: 'yachts',
        91: 'oceanfront',
        92: 'apartments',
    },
    homeaway_uk: {
        1008: 'cheap',
        12: 'hot-tubs',
        23: 'pools',
        24: 'private-pool',
        27: 'dog-and-pet-friendly',
        30: 'beach',
        32: 'beachfront',
        35: 'lake',
        38: 'countryside-and-rural',
        43: 'family-and-child-friendly',
        44: 'luxury',
        60: 'barns',
        61: 'bed-and-breakfasts',
        62: 'boats',
        63: 'bungalows',
        64: 'log-cabins',
        65: 'castles',
        66: 'chalets',
        67: 'country-houses',
        69: 'cottages',
        70: 'mansions',
        71: 'farms',
        72: 'guest-houses',
        73: 'hotels',
        74: 'houses',
        75: 'houseboats',
        76: 'lodges',
        77: 'mills',
        78: 'caravans',
        79: 'resorts',
        80: 'studios',
        81: 'towers',
        82: 'townhouses',
        83: 'villas',
        84: 'yachts',
        91: 'oceanfront',
        92: 'apartments',
    },
    homeaway_nz: {
        1008: 'cheap',
        23: 'pool',
        27: 'pet-friendly',
        30: 'beach',
        32: 'beachfront',
        35: 'lake',
        42: 'waterfront',
        43: 'family',
        44: 'luxury',
        60: 'barns',
        61: 'bed-and-breakfasts',
        62: 'boats',
        63: 'bungalows',
        64: 'cabins',
        65: 'castles',
        66: 'chalets',
        67: 'country-houses',
        69: 'cottages',
        70: 'mansions',
        71: 'farm-stays',
        72: 'guest-houses',
        73: 'hotels',
        74: 'houses',
        75: 'houseboats',
        76: 'lodges',
        77: 'mills',
        78: 'caravans',
        79: 'resorts',
        80: 'studios',
        81: 'towers',
        82: 'townhouses',
        83: 'villas',
        84: 'yachts',
        92: 'apartments',
    },
    bookabach: {
        1008: 'cheap',
        23: 'pool',
        27: 'pet-friendly',
        30: 'beach',
        32: 'beachfront',
        35: 'lake',
        42: 'waterfront',
        43: 'family',
        44: 'luxury',
        60: 'barns',
        61: 'bed-and-breakfasts',
        62: 'boats',
        63: 'bungalows',
        64: 'cabins',
        65: 'castles',
        66: 'chalets',
        67: 'country-houses',
        69: 'cottages',
        70: 'mansions',
        71: 'farm-stays',
        72: 'guest-houses',
        73: 'hotels',
        74: 'houses',
        75: 'houseboats',
        76: 'lodges',
        77: 'mills',
        78: 'caravans',
        79: 'resorts',
        80: 'studios',
        81: 'towers',
        82: 'townhouses',
        83: 'villas',
        84: 'yachts',
        92: 'apartments',
    },
    homeaway_sg: {
        60: 'barns',
        61: 'bed-and-breakfasts',
        62: 'boats',
        63: 'bungalows',
        64: 'cabins',
        65: 'castles',
        66: 'chalets',
        67: 'country-houses',
        69: 'cottages',
        70: 'estates',
        71: 'farmhouses',
        72: 'guest-houses',
        73: 'hotels',
        74: 'houses',
        75: 'houseboats',
        76: 'lodges',
        77: 'mills',
        78: 'caravans',
        79: 'resorts',
        80: 'studios',
        81: 'towers',
        82: 'townhouses',
        83: 'villas',
        84: 'yachts',
        92: 'apartments',
    },
    vrbo: {
        1008: 'cheap',
        10: 'indoor-pool',
        12: 'hot-tub',
        23: 'pool',
        24: 'private-pool',
        27: 'pet-friendly',
        30: 'beach',
        32: 'beachfront',
        35: 'lake',
        36: 'mountain',
        39: 'ski-in-ski-out',
        42: 'waterfront',
        43: 'family',
        44: 'luxury',
        55: 'skiing-and-snowboarding',
        60: 'barns',
        61: 'bed-and-breakfast',
        62: 'boats',
        63: 'bungalows',
        64: 'cabins',
        65: 'castles',
        66: 'chalets',
        67: 'country-houses',
        69: 'cottages',
        70: 'mansions',
        71: 'farmhouses',
        72: 'guest-houses',
        73: 'hotels',
        74: 'houses',
        75: 'houseboats',
        76: 'lodges',
        77: 'mills',
        78: 'caravans-and-rvs',
        79: 'resorts',
        80: 'studios',
        81: 'towers',
        82: 'townhouses',
        83: 'villas',
        84: 'yachts',
        87: 'wheelchair-accessible',
        91: 'oceanfront',
        92: 'condos-and-apartments',
    },
    homeaway_es: {
        23: 'piscina',
        30: 'playa',
        41: 'pueblo',
        60: 'graneros-restaurados',
        61: 'bed-breakfasts',
        62: 'barcos',
        63: 'bungalows',
        64: 'cabañas',
        65: 'castillos',
        66: 'chalets',
        67: 'chateaux-casas-de-campo',
        69: 'casas-rurales',
        70: 'fincas',
        71: 'granjas',
        72: 'casas-de-huéspedes',
        73: 'hoteles',
        74: 'casas',
        75: 'casas-flotantes',
        76: 'lodges',
        77: 'molinos',
        78: 'caravanas',
        79: 'complejos-turísticos',
        80: 'estudios',
        81: 'torres',
        82: 'casas-de-ciudad',
        83: 'villas',
        84: 'yates',
        92: 'apartamentos-pisos',
    },
    homeaway_mx: {
        60: 'graneros',
        61: 'bed-and-breakfasts',
        62: 'embarcaciones',
        63: 'bungalows',
        64: 'cabañas',
        65: 'castillos',
        66: 'chalets',
        67: 'chateaus-casas-de-campo',
        69: 'cabañas',
        70: 'fincas-haciendas',
        71: 'granjas',
        72: 'casas-de-huéspedes',
        73: 'hoteles',
        74: 'casas',
        75: 'casas-flotantes',
        76: 'lodges',
        77: 'molinos',
        78: 'casas-rodantes',
        79: 'resorts',
        80: 'estudios',
        81: 'torres',
        82: 'casas-de-ciudad',
        83: 'villas',
        84: 'yates',
        92: 'departamentos-condominios',
    },
    homeaway_fi: {
        60: 'ladot',
        61: 'aamiaismajoitukset',
        62: 'veneet',
        63: 'bungalowt',
        64: 'mökit',
        65: 'linnat',
        66: 'chalett',
        67: 'chateaut-maalaiskartanot',
        69: 'huvilat',
        70: 'kartanot',
        71: 'maatilat',
        72: 'majatalot',
        73: 'hotellit',
        74: 'talot',
        75: 'asuntolaivat',
        76: 'lomamajat',
        77: 'myllyt',
        78: 'asunto-matkailuvaunut',
        79: 'lomakeskukset',
        80: 'yksiöt',
        81: 'tornit',
        82: 'kaupunkipientalot',
        83: 'huvilat',
        84: 'jahdit',
        92: 'asunnot-huoneistot',
    },
    homeaway_cafr: {
        60: 'granges',
        61: 'gîtes',
        62: 'bateaux',
        63: 'bungalows',
        64: 'chalets-rustiques',
        65: 'châteaux',
        66: 'chalets',
        67: 'châteaux-maisons-de-campagne',
        69: 'chaumières',
        70: 'domaines',
        71: 'fermes',
        72: 'pensions',
        73: 'hôtels',
        74: 'maisons',
        75: 'péniches',
        76: 'auberges',
        77: 'moulins',
        78: 'maisons-mobiles-caravanes',
        79: 'complexes-hôteliers',
        80: 'studios',
        81: 'tours',
        82: 'maisons-de-ville',
        83: 'villas',
        84: 'yachts',
        92: 'appartements-condos',
    },
    abritel: {
        1008: 'pas-cher',
        23: 'piscine',
        24: 'piscine-privée',
        30: 'plage',
        35: 'lac',
        36: 'montagne',
        40: 'ville',
        60: 'granges-aménagées',
        61: 'chambre-dhote',
        62: 'bateaux',
        63: 'bungalow',
        64: 'cabane',
        65: 'châteaux',
        66: 'chalet',
        67: 'manoir',
        69: 'gite',
        70: 'propriétés',
        71: 'ferme',
        72: 'maisons-dhôtes',
        73: 'hôtels',
        74: 'maison',
        75: 'maisons-bateaux',
        76: 'hébergement',
        77: 'moulins',
        78: 'mobil-home',
        79: 'village-vacances',
        80: 'studio',
        81: 'tours',
        82: 'maisons-mitoyennes',
        83: 'villa',
        84: 'yacht',
        8: 'jardin',
        92: 'appartement',
    },
    homeaway_it: {
        10: 'piscina-coperta',
        23: 'piscina',
        27: 'animali-ammessi',
        30: 'spiaggia',
        33: 'centro-città',
        35: 'lago',
        36: 'montagna',
        37: 'mare',
        60: 'rustici',
        61: 'bed-breakfast',
        62: 'barche',
        63: 'bungalow',
        64: 'baite',
        66: 'chalet',
        67: 'case-di-campagna',
        69: 'cottage',
        70: 'tenute',
        71: 'agriturismo',
        72: 'pensione',
        74: 'case',
        75: 'case-galleggianti',
        77: 'mulini',
        78: 'case-mobili-roulotte',
        79: 'villaggio-turistico',
        80: 'monolocali',
        81: 'torri',
        83: 'ville',
        84: 'yacht',
        91: 'fronte-mare',
        92: 'appartamenti',
    },
    homeaway_nl: {
        10: 'binnenzwembad',
        23: 'zwembad',
        27: 'huisdiervriendelijk',
        60: 'schuur',
        61: 'bed-and-breakfast',
        62: 'boten',
        63: 'bungalows',
        64: 'trekkershut',
        65: 'kastelen',
        66: 'chalet',
        67: 'landhuis',
        69: 'huisje',
        70: 'landgoed',
        71: 'boerderij',
        72: 'pension',
        73: 'familiehotel',
        74: 'huizen',
        75: 'woonboot',
        76: 'blokhut',
        77: 'molens',
        78: 'stacaravan',
        79: 'resort',
        80: 'studio',
        81: 'torens',
        82: 'stadswoningen',
        83: 'villa',
        84: 'jachten',
        92: 'appartement',
    },
    homeaway_no: {
        60: 'låver',
        61: 'bed-breakfast',
        62: 'båter',
        63: 'bungalower',
        64: 'hytter',
        65: 'slott',
        66: 'skihytter',
        67: 'hus-på-landet-gods',
        69: 'sommerhus',
        70: 'gods',
        71: 'gårdshus',
        72: 'gjestehus',
        73: 'hoteller',
        74: 'hus',
        75: 'husbåter',
        76: 'jakthytter',
        77: 'møller',
        78: 'husvogner-campingvogner',
        79: 'resorter',
        80: 'ettromsleiligheter',
        81: 'tårn',
        82: 'townhouse',
        83: 'villaer',
        84: 'yachter',
        92: 'leiligheter-sameie',
    },
    homeaway_pl: {
        60: 'stodoły',
        61: 'bed-breakfast',
        62: 'łodzie',
        63: 'bungalowy',
        64: 'domki-w-górach',
        65: 'zamki',
        66: 'domki-alpejskie',
        67: 'rezydencje',
        69: 'domki-letniskowe',
        70: 'posiadłości',
        71: 'gospodarstwa-wiejskie',
        72: 'domy-gościnne',
        73: 'hotele',
        74: 'domy',
        75: 'barki-mieszkalne',
        76: 'ośrodki',
        77: 'młyny',
        78: 'kampery-przyczepy-kempingowe',
        79: 'kurorty',
        80: 'studia',
        81: 'wieżowce',
        82: 'kamienice',
        83: 'wille',
        84: 'jachty',
        92: 'apartamenty-mieszkania',
    },
    homeaway_br: {
        60: 'celeiros',
        61: 'cama-e-café-da-manhã',
        62: 'barcos',
        63: 'bangalôs',
        64: 'cabanas',
        65: 'castelos',
        66: 'chalés',
        67: 'casas-de-campo',
        69: 'casas-rústicas',
        70: 'mansões',
        71: 'fazendas',
        72: 'pousadas-pensões',
        73: 'hotéis',
        74: 'casas',
        75: 'casas-flutuantes',
        76: 'estalagens',
        77: 'moinhos',
        78: 'trailers',
        79: 'resorts',
        80: 'estúdios',
        81: 'torres',
        82: 'sobrados',
        83: 'vilas',
        84: 'iates',
        92: 'apartamentos',
    },
    homeaway_pt: {
        60: 'celeiros',
        61: 'bed-breakfast',
        62: 'barcos',
        63: 'bungalows',
        64: 'cabanas',
        65: 'castelos',
        66: 'chalés',
        67: 'casas-de-campo',
        69: 'casas-rústicas',
        70: 'herdades',
        71: 'quintas',
        72: 'casas-de-hóspedes',
        73: 'hotéis',
        74: 'casas',
        75: 'casas-barco',
        76: 'hospedagens',
        77: 'moinhos',
        78: 'caravanas',
        79: 'resorts',
        80: 'estúdios',
        81: 'torres',
        82: 'casas-geminadas',
        83: 'villas',
        84: 'iates',
        92: 'apartamentos',
    },
    homeaway_se: {
        60: 'ladugårdar',
        61: 'bed-breakfasts',
        62: 'båtar',
        63: 'bungalower',
        64: 'stugor',
        65: 'slott',
        66: 'fjällstugor',
        67: 'herrgårdar',
        69: 'fritidshus',
        70: 'gårdar',
        71: 'bondgårdar',
        72: 'gästhus',
        73: 'hotell',
        74: 'hus',
        75: 'husbåtar',
        76: 'sportstugor',
        77: 'kvarnar',
        78: 'husvagnar-husbilar',
        79: 'resorter',
        80: 'enrumslägenheter',
        81: 'torn',
        82: 'hus-i-stan',
        83: 'villor',
        84: 'yachter',
        92: 'lägenheter',
    },
};

export function getSlug(siteName, refinementId) {
    const bySiteName = SLUGS[siteName] || {};
    return bySiteName[refinementId];
}
